(ns minorodata.localforage.subs
  (:require [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [minorodata.localforage.core :refer [db]]
            [applied-science.js-interop :as js-interop]))

(re-frame/reg-sub
 :localforage.subs/get
 (fn [_ [_ key callback]]
   (js-interop/call db :getItem key callback)))
